import { CastFunction } from "./cast-function";
import { Language } from "./language";
import { PlatformLanguageCode } from "./platform-language-code";

export class CastMetadataInfos {
  $type?: string | null = null;
  order: number | null = 0;
  function: string | null = null;
  functionEnum: CastFunction | null = null;
  name: string | null = null;
  lastname: string | null = null;
  charName: string | null = null;
  languageCode: PlatformLanguageCode | null = null;
  languageLocalized: Language | null = null;
  languageLocalizedCultureId: number | null = 0;

  constructor(init?: Partial<CastMetadataInfos>) {
    Object.assign(this, init);
  }
}
